import _ from "lodash";
import React, { useCallback, useEffect, useMemo } from "react";
import { Button } from "reactstrap";
import {
  MAILCHIMP_GET_LOADING,
  MAILCHIMP_SYNC_LOADING,
} from "../../../../constants/loading.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useMailchimpCore } from "../../../../cores/mailchimp";
import { useMeCore } from "../../../../cores/me";
import {
  SocialProviderId,
  SocialProviderName,
} from "../../../../cores/socialPost/config";
import { useIntl } from "react-intl";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import SocialCard from "../SocialCard";
import { MailchimpIcon } from "./MailchimpIcon";

export default function MailchimpBindCard() {
  const intl = useIntl();
  const { get, settings, unbind, login } = useMailchimpCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { isLoading } = useGlobalCore();

  useEffect(() => {
    get(company!.id);
  }, [company, get]);

  const isActive = useMemo((): boolean => !_.isEmpty(settings), [settings]);

  const socialProvider = useMemo(
    (): SocialProvider => ({
      id: SocialProviderId.Mailchimp,
      name: SocialProviderName.Mailchimp,
      icon: <MailchimpIcon size="6x" active={isActive} />,
      displayName: settings?.name,
      avatar: settings?.avatarUrl,
    }),
    [isActive, settings]
  );

  const handleBind = useCallback(async () => {
    const loginUrl = await login(company!.id);
    if (loginUrl) window.open(loginUrl, "_self");
  }, [company, login]);

  const handleUnbind = useCallback(() => {
    unbind(company!.id, () => {
      getMeSocialSettings(company?.id!);
    });
  }, [company, unbind, getMeSocialSettings]);

  return (
    <SocialCard
      social={socialProvider}
      bindLoading={isLoading(MAILCHIMP_SYNC_LOADING)}
      getLoading={isLoading(MAILCHIMP_GET_LOADING)}
      showSynchronizer={false}
    >
      <Button
        className="w-100"
        color="primary"
        outline={isActive}
        onClick={!isActive ? handleBind : handleUnbind}
      >
        {!isActive 
          ? intl.formatMessage({ id: "app.home.syncUp" })
          : intl.formatMessage({ id: "app.home.disconnect" })
        }
      </Button>
    </SocialCard>
  );
}
